/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_SubtitleInputs */

const en_wc_tut_subtitle = /** @type {(inputs: Wc_Tut_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A practical beginner's guide to the WordCraft app. If you know Word, skim the headings: most things work exactly the way you expect.`)
};

/**
* | output |
* | --- |
* | "A practical beginner's guide to the WordCraft app. If you know Word, skim the headings: most things work exactly the way you expect." |
*
* @param {Wc_Tut_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_subtitle = /** @type {((inputs?: Wc_Tut_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_subtitle(inputs)
});
export { wc_tut_subtitle as "wc.tut.subtitle" }